import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { GradedUnit } from './graded-unit.model';

export class GradedUnitStateModel extends EntityStateModel<GradedUnit> {}
